<template>
  <div class="loginElement">
    <el-form :model="ruleForm" :rules="rules" label-position="left" ref="ruleForm" label-width="100px">
      <el-form-item label="帐号：" prop="username">
        <el-input  placeholder="请输入帐号"
            onkeydown="if(event.keyCode==13) {document.getElementById('btn').click();return false;}"
            v-model="ruleForm.username"></el-input>
      </el-form-item>
      <el-form-item  label="密码：" prop="password">
        <el-input type="password" show-password placeholder="请输入密码"
                  onkeydown="if(event.keyCode==13) {document.getElementById('btn').click();return false;}"
                  v-model="ruleForm.password"/>
      </el-form-item>
      <el-form-item label="验证码：" prop="code">
        <div style="display: flex; align-items: center;">
          <el-input type="text"  placeholder="请输入验证码"
                    onkeydown="if(event.keyCode==13) {document.getElementById('btn').click();return false;}"
                    v-model="ruleForm.code"></el-input>
          <div class="login-code">
            <img :src="codeUrl"
                 @click="getCode"
                 alt="验证码">
          </div>
        </div>
      </el-form-item>
    </el-form>
    <div style="width: 100%;text-align: center">
      <el-button style="width: 100%;" type="primary" id="btn" @click="login()">登录</el-button>
    </div>
  </div>
</template>

<script>
import * as u from "@/utils/util";

export default {
  name: "loginElement",
  data(){
    return{
      //登录表单
      ruleForm: { 
        code: '',
        randomStr: u.uuid(),
      },
      //登录校验
      rules: {
        username: [
          {required: true, message: '请输入帐号', trigger: 'blur'},
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
        ],
        code: [
          {required: true, message: '请输入验证码', trigger: 'blur'},
        ],
      },
      //验证码图片url
      codeUrl: "",
    }
  },
  created(){
    this.getCode();
  },
  methods: {
    //获取验证码
    getCode() {
      this.$HttpService.get("/sys-login/getCode", {
        randomStr: this.ruleForm.randomStr,
      }).then(res => {
        this.codeUrl = res;
        this.randomStr = u.uuid();
      })
    },
    //登录
    login() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$HttpService.post("/sys-login/login",this.ruleForm,).then(res => {
            //设置存储用户基本信息
            this.$util.setLoginInfo(res);
            
            // 设置登录状态到 Vuex store
            this.$store.commit('SET_LOGIN_STATE', true);
            
            // 检查是否有重定向参数
            const redirect = this.$route.query.redirect;
            
            //跳转路由
            setTimeout(() => {
              if (redirect) {
                // 如果有重定向参数，跳转到指定页面
                this.$router.push(redirect);
              } else {
                // 否则跳转到默认页面
                this.$router.push({ path: "/file/myFileTree" });
              }
            }, 200)
          }).catch(() => {
            this.getCode();
          })
        }
      });
    }
  }
}
</script>


<style scoped lang="scss">
.loginElement {
  .login-code {
    margin-left: 10px;
    cursor: pointer;
    
    img {
      height: 40px;
      border-radius: 4px;
    }
  }

  // ==================== 移动端适配 ====================
  @media screen and (max-width: 768px) {
    ::v-deep .el-form {
      .el-form-item {
        margin-bottom: 16px;

        .el-form-item__label {
          font-size: 13px;
          line-height: 38px;
          padding: 0 6px 0 0;
          width: 65px !important;
        }

        .el-form-item__content {
          line-height: 38px;
          margin-left: 65px !important;

          .el-input {
            .el-input__inner {
              height: 38px;
              line-height: 38px;
              font-size: 14px;
              padding: 0 12px;
              border-radius: 5px;
            }

            .el-input__suffix {
              .el-input__suffix-inner {
                line-height: 38px;

                .el-icon-view,
                .el-icon-circle-close {
                  font-size: 15px;
                }
              }
            }
          }
        }
      }
    }

    .login-code {
      margin-left: 6px;
      flex-shrink: 0;

      img {
        height: 38px;
        width: 85px;
        border-radius: 5px;
      }
    }

    ::v-deep .el-button {
      height: 38px;
      font-size: 15px;
      border-radius: 5px;
      font-weight: 500;
    }
  }

  // 小屏幕手机适配（宽度小于 480px）
  @media screen and (max-width: 480px) {
    ::v-deep .el-form {
      .el-form-item {
        margin-bottom: 14px;

        .el-form-item__label {
          font-size: 13px;
          line-height: 36px;
          width: 60px !important;
        }

        .el-form-item__content {
          line-height: 36px;
          margin-left: 60px !important;

          .el-input {
            .el-input__inner {
              height: 36px;
              line-height: 36px;
              font-size: 14px;
              padding: 0 10px;
            }

            .el-input__suffix {
              .el-input__suffix-inner {
                line-height: 36px;
              }
            }
          }
        }
      }
    }

    .login-code {
      margin-left: 6px;

      img {
        height: 36px;
        width: 80px;
      }
    }

    ::v-deep .el-button {
      height: 36px;
      font-size: 14px;
    }
  }

  // 横屏模式适配
  @media screen and (max-width: 768px) and (orientation: landscape) {
    ::v-deep .el-form {
      .el-form-item {
        margin-bottom: 12px;

        .el-form-item__label {
          line-height: 34px;
        }

        .el-form-item__content {
          line-height: 34px;

          .el-input {
            .el-input__inner {
              height: 34px;
              line-height: 34px;
              font-size: 13px;
            }

            .el-input__suffix {
              .el-input__suffix-inner {
                line-height: 34px;
              }
            }
          }
        }
      }
    }

    .login-code {
      img {
        height: 34px;
        width: 75px;
      }
    }

    ::v-deep .el-button {
      height: 34px;
      font-size: 13px;
    }
  }
}
</style>